import { commonFetch, fetch } from "./fetch";

// 获取产品列表
export function getListByCustomerCode2(data: {
  customerCode: string;
  productGroup: string;
}): Promise<ProductListItem[]> {
  return commonFetch(
    "/crm-dms/v1/contract/contractProduct/getListByCustomerCode2",
    true,
    data
  );
}

// 获取储罐编码
export function findByContactCode(data: {
  customerCode: string;
  servedCode: string;
  productCode: string;
}): Promise<TTsListItem[]> {
  return commonFetch("/crm-mdm/v1/tank/tank/findByContactCode", true, data);
}

// 通过储罐号获取合同信息
export function getContract4wxOrderCreate(data: {
  tankNo: string;
}): Promise<{ orderMode: string }> {
  return commonFetch(
    "/crm-dms/v1/contract/contractProDevice/getContract4wxOrderCreate",
    true,
    data
  );
}

// 查询液位信息
export function findByTtsId(data: { tankNum: string }): Promise<TTsInfo[]> {
  return commonFetch("/crm-mdm/v1/tank/tank/findByTtsId", true, data);
}

// 校验订单是否重复
export function quickCreateListCheck(data: any): Promise<any> {
  return fetch({
    url: "/crm-dms/v1/order/yingde/quickCreateListCheck",
    method: "post",
    data,
  });
}

// 提交订单
export function quickCreateList(data: any): Promise<any> {
  return fetch({
    url: "/crm-dms/v1/order/yingde/quickCreateList",
    method: "post",
    data,
  });
}

// 分页查询所有数据(包含客户主数据联系人)：下单界面专用
export function findAllByConditions(data: any): Promise<any> {
  return fetch({
    url: "/crm-dms/v1/orderReceiveContactEntity/findAllByConditions",
    method: "get",
    data,
  });
}

// 新增联系人
export function createOrUpdate(data: any): Promise<any> {
  return fetch({
    url: "/crm-dms/v1/orderReceiveContactEntity/createOrUpdate",
    method: "post",
    data,
  });
}

const quictApi = {
  getListByCustomerCode2,
  findByContactCode,
  getContract4wxOrderCreate,
  findByTtsId,
  quickCreateListCheck,
  quickCreateList,
  findAllByConditions,
  createOrUpdate,
};

export default quictApi;
